import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-fdf635e2"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "game-panel" };
var _hoisted_2 = { class: "game-panel-inner" };
var _hoisted_3 = { class: "leaderboard" };
var _hoisted_4 = { class: "content-wrap" };
var _hoisted_5 = { class: "content" };
var _hoisted_6 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "texts-wrap" }, [
    /*#__PURE__*/ _createElementVNode("span", { class: "home-title-head font-ang" }, "Miner's Rush"),
    /*#__PURE__*/ _createElementVNode("span", { class: "home-title font-ang" }, "Manage Account")
], -1); });
var _hoisted_7 = { class: "col-12 col-md-12 col-xs-12" };
var _hoisted_8 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "col-np-1 col-np-md-0 col-np-xs-0" }, null, -1); });
var _hoisted_9 = { class: "col-np-10 col-np-md-12 col-np-xs-12" };
var _hoisted_10 = { class: "panel" };
var _hoisted_11 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "panel-top" }, null, -1); });
var _hoisted_12 = { class: "panel-middle" };
var _hoisted_13 = { class: "panel-content" };
var _hoisted_14 = { key: 0 };
var _hoisted_15 = { key: 0 };
var _hoisted_16 = { key: 1 };
var _hoisted_17 = {
    key: 2,
    class: "wallet"
};
var _hoisted_18 = {
    key: 3,
    class: "wallet-connect"
};
var _hoisted_19 = { key: 1 };
var _hoisted_20 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", null, "Please log in to your account to continue.", -1); });
var _hoisted_21 = {
    key: 0,
    class: "error"
};
var _hoisted_22 = { key: 2 };
var _hoisted_23 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", null, "Your browser doesn't support Web3. Please try another browser.", -1); });
var _hoisted_24 = [
    _hoisted_23
];
var _hoisted_25 = { key: 3 };
var _hoisted_26 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("p", null, "Your browser doesn't support Web3 functionality. Please use MetaMask browser.", -1); });
var _hoisted_27 = { class: "delete-button" };
var _hoisted_28 = ["href"];
var _hoisted_29 = { key: 4 };
var _hoisted_30 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "panel-bottom" }, null, -1); });
var _hoisted_31 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "col-np-1 col-np-md-0 col-np-xs-0" }, null, -1); });
var _hoisted_32 = /*#__PURE__*/ _withScopeId(function () { /*#__PURE__*/ return _createElementVNode("div", { class: "top-divider" }, null, -1); });
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createElementVNode("div", _hoisted_7, [
                            _hoisted_8,
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _hoisted_11,
                                    _createElementVNode("div", _hoisted_12, [
                                        _createElementVNode("div", _hoisted_13, [
                                            ($data.store.getters.isLogged && $data.isSupportedBrowser)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                                                    ($data.store.getters.connectedWallet != null && $data.store.getters.connectedWallet != '')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_15, "Your browser supports Web3! You can continue to manage your profile or visit Shop!"))
                                                        : (_openBlock(), _createElementBlock("p", _hoisted_16, "Please connect wallet!")),
                                                    ($data.store.getters.connectedWallet != null && $data.store.getters.connectedWallet != '')
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                                            _createElementVNode("p", null, "Wallet: " + _toDisplayString($data.store.getters.connectedWallet.slice(0, 5) + "..." + $data.store.getters.connectedWallet.substr($data.store.getters.connectedWallet.length - 5)), 1),
                                                            _createElementVNode("div", {
                                                                class: "delete-button",
                                                                onClick: _cache[0] || (_cache[0] = function ($event) { return ($options.router().push('/profile')); })
                                                            }, "Profile"),
                                                            _createElementVNode("div", {
                                                                class: "delete-button",
                                                                onClick: _cache[1] || (_cache[1] = function ($event) { return ($options.router().push('/shop')); })
                                                            }, "Shop")
                                                        ]))
                                                        : (_openBlock(), _createElementBlock("span", _hoisted_18, [
                                                            _createElementVNode("div", {
                                                                class: "delete-button",
                                                                onClick: _cache[2] || (_cache[2] = function ($event) { return ($options.getWalletMetamask()); })
                                                            }, "Connect Wallet")
                                                        ]))
                                                ]))
                                                : _createCommentVNode("", true),
                                            (!$data.store.getters.isLogged && $data.store.state.isMobile)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                                    _hoisted_20,
                                                    _createElementVNode("form", {
                                                        onSubmit: _cache[6] || (_cache[6] = _withModifiers(function () { }, ["prevent"]))
                                                    }, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return (($data.username) = $event); }),
                                                            type: "text",
                                                            placeholder: "Username...",
                                                            class: "panel-input"
                                                        }, null, 512), [
                                                            [_vModelText, $data.username]
                                                        ]),
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return (($data.password) = $event); }),
                                                            type: "password",
                                                            placeholder: "Password...",
                                                            class: "panel-input"
                                                        }, null, 512), [
                                                            [_vModelText, $data.password]
                                                        ]),
                                                        _createElementVNode("input", {
                                                            type: "submit",
                                                            name: "Log In",
                                                            class: "panel-input",
                                                            onClick: _cache[5] || (_cache[5] =
                                                                //@ts-ignore
                                                                function () {
                                                                    var args = [];
                                                                    for (var _i = 0; _i < arguments.length; _i++) {
                                                                        args[_i] = arguments[_i];
                                                                    }
                                                                    return ($options.login && $options.login.apply($options, args));
                                                                })
                                                        })
                                                    ], 32),
                                                    ($data.error != '')
                                                        ? (_openBlock(), _createElementBlock("p", _hoisted_21, "Error: " + _toDisplayString($data.error), 1))
                                                        : _createCommentVNode("", true)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (!$data.isSupportedBrowser)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, _hoisted_24))
                                                : _createCommentVNode("", true),
                                            (!$data.isSupportedBrowser && $data.store.state.isMobile)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                                                    _hoisted_26,
                                                    _createElementVNode("div", _hoisted_27, [
                                                        _createElementVNode("a", {
                                                            href: 'https://metamask.app.link/dapp/minersrush.xyz/mobileWallet?token=' + $data.store.getters.getToken
                                                        }, "Open MetaMask", 8, _hoisted_28)
                                                    ])
                                                ]))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_29, [
                                                    _createElementVNode("div", {
                                                        class: "delete-button",
                                                        onClick: _cache[7] || (_cache[7] = function ($event) { return ($options.router().push('/')); })
                                                    }, "Home")
                                                ]))
                                        ])
                                    ]),
                                    _hoisted_30
                                ])
                            ]),
                            _hoisted_31
                        ])
                    ])
                ]),
                _hoisted_32
            ])
        ])
    ]));
}
